module.exports = __webpack_public_path__ + "img/H-B-5-unload-standup-shadow.ea547f8e.png";